module.exports = __webpack_public_path__ + "static/media/thumbnail-moradias.c49213ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thumbnail-moradias.png
// module id = 396
// module chunks = 0